import React, { useEffect, useRef, useState } from "react"

import { PackageTableHeader } from "../../styles/Table.styled"

import HeaderCell from "./Cell"

const TableHeader = ({
  component: {
    packageTableHeaderTitle,
    packageTableHeaderSubtitle,
    packageTableHeaderCta,
    packageTableHeaderPackages,
  },
  isTableNavSticky,
}) => {
  const [height, setHeight] = useState(0)
  const headerRef = useRef(null)

  useEffect(() => {
    setHeight(headerRef.current.clientHeight)
  }, [])

  return (
    <PackageTableHeader
      ref={headerRef}
      isTableNavSticky={isTableNavSticky}
      headerHeight={height}
    >
      <tr>
        <HeaderCell
          title={packageTableHeaderTitle}
          subtitle={packageTableHeaderSubtitle}
          cta={packageTableHeaderCta}
          width="245px"
        />
        {packageTableHeaderPackages?.map((headerPackage, index) => (
          <HeaderCell
            key={index}
            title={headerPackage?.title}
            cta={headerPackage?.callToAction}
            stars={headerPackage?.stars}
            color={headerPackage?.color}
            scope="col"
          />
        ))}
      </tr>
    </PackageTableHeader>
  )
}

export default TableHeader
